<!--
 * @Author: 1739017283@qq.com
 * @Date: 2025-04-08 09:16:42
 * @LastEditors: 1739017283@qq.com
 * @LastEditTime: 2025-04-08 10:33:56
 * @FilePath: \knowledge-graph\src\components\Login\index.vue
 * @Description: 登录的操作
-->
<template>
  <div class="com-login" :class="{ show }" @click.stop="show = false">
    <div @click.stop>
      <component :is="curShow" @close="show = false" @jump="jump" v-if="show" />
    </div>
  </div>
</template>
<script>
import login from './login.vue'
import regist from './regist.vue'
import forget from './forget.vue'
export default {
  name: 'comLogin',
  components: { login, regist, forget },
  data () {
    return {
      show: false,
      curShow: 'login'
    }
  },
  methods: {
    open () {
      this.curShow = 'login'
      this.show = true
    },
    jump (type) {
      this.curShow = type
    }
  }
}
</script>
